module.exports = __webpack_public_path__ + "static/media/recover.113a1e25.png";